export type RegisterMode = "enroll" | "sign_up"

export const useAppSettings = () => {
  const isMultiTenant = window.APP_CONFIG.TENANT_MODE === "multi-tenant"
  const enrollmentRegistration = window.APP_CONFIG.ENROLLMENT_REGISTRATION
  const registerMode: RegisterMode = enrollmentRegistration ? "enroll" : "sign_up"

  return { isMultiTenant, enrollmentRegistration, registerMode }
}
